export const PRODUCT = 'splash';
export const BUSINESS_UNIT = 'event';
export const DD_HOST_SERVICE_NAME = 'splash-planner-ui';
export const DD_GUEST_SERVICE_NAME = 'splash-guest-ui';
